module.exports = __webpack_public_path__ + "img/banner-2-min.3be6e57f.png";